import React, {useState, useEffect, useRef} from 'react';
import post from '../utils/post.js';
import AppHeader from '../components/AppHeader.js';
import Calendar from '../components/Calendar.js';
import ExercisePlan from '../components/ExercisePlan.js';
import $ from 'jquery';
import ChartArea from '../components/ChartArea.js';
import ExerciseWorkoutRec from '../components/ExerciseWorkoutRec.js';
import '../styles/exercise.scss';

function getShortToolbarUserName(firstName, lastName, nickname) {
	const normalizedFirstName = String(firstName || '').trim();
	const normalizedLastName = String(lastName || '').trim();
	const normalizedNickname = String(nickname || '').trim();
	const displayFirstName = normalizedFirstName || normalizedNickname;

	if (displayFirstName === '') {
		return '';
	}

	if (normalizedLastName === '') {
		return displayFirstName;
	}

	return `${displayFirstName} ${normalizedLastName.charAt(0).toUpperCase()}.`;
}

function formatShortWeekday(date) {
	const shortWeekday = date.toLocaleDateString('cs-CZ', {weekday: 'short'});
	return shortWeekday.charAt(0).toUpperCase() + shortWeekday.slice(1);
}

function formatWorkoutName(item) {
	const recOrder = parseInt(item.REC_ORDER, 10);

	if (Number.isInteger(recOrder) && recOrder > 0) {
		return `${recOrder}. ${item.NAME}`;
	}

	return item.NAME;
}

function timeToSeconds(value) {
	const parts = String(value || '').split(':');

	if (parts.length !== 3) {
		return 0;
	}

	return parseInt(parts[0], 10) * 3600 + parseInt(parts[1], 10) * 60 + parseInt(parts[2], 10);
}

function formatDuration(totalSec) {
	const totalMin = Math.round(totalSec / 60);

	if (totalMin < 60) {
		return `${totalMin} min`;
	}

	return `${Math.floor(totalMin / 60)}:${String(totalMin % 60).padStart(2, '0')} h`;
}

// Souhrn celého dne napříč všemi cviky – počítá se z už načtených záznamů, bez dalšího dotazu.
function getDaySummary(workouts) {
	const summary = {volume: 0, sets: 0, underLoadSec: 0, firstTms: '', lastTms: ''};

	(workouts || []).forEach((item) => {
		(item.recs || []).forEach((rec) => {
			summary.sets += 1;

			if (item.TYPEID === 1) {
				summary.volume += (parseFloat(rec.WEIGHT) || 0) * (parseInt(rec.CNT, 10) || 0);
			} else {
				summary.underLoadSec += parseInt(rec.TIMESEC, 10) || 0;
			}

			if (rec.CRDT_TMS) {
				if (summary.firstTms === '' || rec.CRDT_TMS < summary.firstTms) {
					summary.firstTms = rec.CRDT_TMS;
				}

				if (summary.lastTms === '' || rec.CRDT_TMS > summary.lastTms) {
					summary.lastTms = rec.CRDT_TMS;
				}
			}
		});
	});

	return summary;
}

export default function Exercise({usrInfo, timerCnt}) {
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState([]);
	const [targetUsrName, setTargetUsrName] = useState('');
	const [targetUsrFirstName, setTargetUsrFirstName] = useState('');
	const [targetUsrLastName, setTargetUsrLastName] = useState('');
	const [targetUsrNickname, setTargetUsrNickname] = useState('');
	const [targetUsrWeight, setTargetUsrWeight] = useState(0);
	const [isEditingWeight, setIsEditingWeight] = useState(false);
	const [editWeightValue, setEditWeightValue] = useState('');
	const [showCal, setShowCal] = useState(false);
	const [today, setToday] = useState(new Date().getDate() + '.' + (new Date().getMonth() + 1) + '.' + new Date().getFullYear());
	const [now, setNow] = useState(new Date().getDate() + '.' + (new Date().getMonth() + 1) + '.' + new Date().getFullYear());
	const [showPlan, setShowPlan] = useState(false);
	const [addVal1, setAddVal1] = useState([]);
	const [addVal2, setAddVal2] = useState([]);
	const [started, setStarted] = useState(false);
	const [startedWorkoutId, setStartedWorkoutId] = useState(0);
	const [timerOwnerWorkoutId, setTimerOwnerWorkoutId] = useState(0);
	const [timeSec, setTimeSec] = useState(0);
	const timerIntervalId = useRef(null);
	const timerStartedAt = useRef(0);
	const [selectedPlan, setSelectedPlan] = useState(0);
		const [targetUsrId, setTargetUsrId] = useState(0);
	const shortTargetUsrName = getShortToolbarUserName(targetUsrFirstName, targetUsrLastName, targetUsrNickname);

	const parts = today.split('.');
	const d = new Date(parts[2], parts[1] - 1, parts[0]);
	const todayShortName = formatShortWeekday(d);

	const applyTargetUsrMeta = (responseData) => {
		setTargetUsrName(responseData.target_usr_name || '');
		setTargetUsrFirstName(responseData.target_usr_firstname || '');
		setTargetUsrLastName(responseData.target_usr_lastname || '');
		setTargetUsrNickname(responseData.target_usr_nickname || '');
		setTargetUsrWeight(parseFloat(responseData.target_usr_weight) || 0);
	};

	useEffect(() => {
		const pathUsrId = parseInt(window.location.pathname.split('/')[2], 10);
		const nextTargetUsrId = Number.isInteger(pathUsrId) && pathUsrId > 0 ? pathUsrId : 0;

		setTargetUsrId(nextTargetUsrId);
		setNow(new Date().getDate() + '.' + (new Date().getMonth() + 1) + '.' + new Date().getFullYear());
		getData(today, nextTargetUsrId);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const getData = (DT, requestedUsrId = targetUsrId) => {
		setLoading(true);
		const payload = {DT: DT};

		if (requestedUsrId > 0) {
			payload.USRID = requestedUsrId;
		}

		post('getListExercise', payload)
			.then((res) => {
				setData(res.data);
				applyTargetUsrMeta(res.data);
				setLoading(false);
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	useEffect(() => {
		const newVal1 = [];
		const newVal2 = [];

		data.data?.forEach((item) => {
			if (parseInt(item.TYPEID) === 1) {
				newVal1[item.WORKOUTID] = item.LAST_CNT;
				newVal2[item.WORKOUTID] = item.LAST_WEIGHT;
			} else {
				newVal1[item.WORKOUTID] = item.LAST_TIMESEC_M;
				newVal2[item.WORKOUTID] = item.LAST_TIMESEC_S;
			}
		});

		setAddVal1(newVal1);
		setAddVal2(newVal2);

		if ((data.data?.length || 0) === 0) {
			setSelectedPlan(0);
		} else if (selectedPlan > data.data.length - 1) {
			setSelectedPlan(data.data.length - 1);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data]);

	const showCalendar = () => {
		setShowCal(true);
	};

	const closeCal = () => {
		setShowCal(false);
	};

	const todayChange = (val) => {
		setToday(val);
		getData(val);
	};

	const setDTToNow = () => {
		todayChange(now);
	};

	const prevDay = () => {
		let parts = today.split('.');
		let d = new Date(parts[2], parts[1] - 1, parts[0]);
		d.setDate(d.getDate() - 1);
		let newDate = d.getDate() + '.' + (d.getMonth() + 1) + '.' + d.getFullYear();

		todayChange(newDate);
	};

	const nextDay = () => {
		let parts = today.split('.');
		let d = new Date(parts[2], parts[1] - 1, parts[0]);
		d.setDate(d.getDate() + 1);
		let newDate = d.getDate() + '.' + (d.getMonth() + 1) + '.' + d.getFullYear();

		todayChange(newDate);
	};

	const handleRefresh = () => {
		getData(today, targetUsrId);
	};

	const handlePlan = () => {
		setShowPlan(true);
	};

	const closePlan = () => {
		setShowPlan(false);
	};

	const updatePlan = (recs) => {
		setLoading(true);

		let formdata = [];
		recs.forEach((item) => {
			//--- Cvik ve více partiích je v plánu vícekrát
			if (item.ISCHECKED === 1 && !formdata.includes(item.ID)) formdata.push(item.ID);
		});

		const payload = {DT: today, CHCK: formdata};

		if (targetUsrId > 0) {
			payload.USRID = targetUsrId;
		}

		post('saveExercisePlan', payload)
			.then((res) => {
				setData(res.data);
				applyTargetUsrMeta(res.data);
				setLoading(false);
				getData(today, targetUsrId); // Re-fetch data for the currently selected day
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	const selectWorkout = (index) => {
		if (index > data.data.length - 1) {
			index = data.data.length - 1;
		}
		if (index < 0) {
			index = 0;
		}

		setSelectedPlan(index);
	};

	const handleSaveWeight = () => {
		setLoading(true);
		const payload = { WEIGHT: editWeightValue };

		if (targetUsrId > 0) {
			payload.USRID = targetUsrId;
		}

		post('saveTargetUserWeight', payload)
			.then((res) => {
				setData(res.data);
				applyTargetUsrMeta(res.data);
				setIsEditingWeight(false);
				setLoading(false);
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	const setAddVal1Val = (val, workouteId) => {
		setAddVal1((prev) => {
			const updated = [...prev];
			updated[workouteId] = val;
			return updated;
		});
	};

	const setAddVal2Val = (val, workouteId) => {
		setAddVal2((prev) => {
			const updated = [...prev];
			updated[workouteId] = val;
			return updated;
		});
	};

	const addWorkout = (workouteId, typeId) => {
		let val1 = addVal1[workouteId] || 0;
		let val2 = addVal2[workouteId] || 0;

		setLoading(true);
		const payload = {DT: today, WORKOUTID: workouteId, TYPEID: typeId, VAL1: val1, VAL2: val2};

		if (targetUsrId > 0) {
			payload.USRID = targetUsrId;
		}

		post('addExerciseWorkout', payload)
			.then((res) => {
				setData(res.data);
				applyTargetUsrMeta(res.data);
				setLoading(false);
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	const showHideTimer = (workouteId) => {
		if ($('#TIMER_' + workouteId).is(':visible') === false) {
			$('#TIMER_' + workouteId).slideDown(300);
			$('#TIMER_START_' + workouteId).show();
			$('#TIMER_STOP_' + workouteId).hide();
			setTimerOwnerWorkoutId(workouteId);
			setTimeSec(0);
		} else {
			$('#TIMER_' + workouteId).slideUp(300);
			timerStartedAt.current = 0;
			setStarted(false);
			setStartedWorkoutId(0);
			setTimerOwnerWorkoutId(0);
			setTimeSec(0);
		}
	};

	// Elapsed time is derived from the start timestamp, not counted up, so it stays correct
	// even when the mobile browser freezes timers while the app is in the background.
	const readElapsedSec = () => {
		if (timerStartedAt.current === 0) {
			return 0;
		}

		return Math.max(0, Math.round((Date.now() - timerStartedAt.current) / 1000));
	};

	useEffect(() => {
		if (!started) {
			if (timerIntervalId.current) {
				clearInterval(timerIntervalId.current);
				timerIntervalId.current = null;
			}

			return;
		}

		const syncTimer = () => setTimeSec(readElapsedSec());

		syncTimer();
		timerIntervalId.current = setInterval(syncTimer, 1000);
		document.addEventListener('visibilitychange', syncTimer);
		window.addEventListener('focus', syncTimer);
		window.addEventListener('pageshow', syncTimer);

		return () => {
			if (timerIntervalId.current) {
				clearInterval(timerIntervalId.current);
				timerIntervalId.current = null;
			}

			document.removeEventListener('visibilitychange', syncTimer);
			window.removeEventListener('focus', syncTimer);
			window.removeEventListener('pageshow', syncTimer);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [started]);

	const startTimer = (workoutId) => {
		$('.TIMER_START').hide();
		$('.TIMER_STOP').show();

		timerStartedAt.current = Date.now();
		setStarted(true);
		setTimeSec(0);
		setStartedWorkoutId(workoutId);
		setTimerOwnerWorkoutId(workoutId);
		$('#TIMER_START_' + workoutId).hide();
		$('#TIMER_STOP_' + workoutId).show();
	};

	const stopTimer = () => {
		$('.TIMER_START').show();
		$('.TIMER_STOP').hide();

		$('#TIMER_START_' + startedWorkoutId).show();
		$('#TIMER_STOP_' + startedWorkoutId).hide();

		const stoppedWorkoutId = startedWorkoutId;
		const elapsedSec = readElapsedSec();

		timerStartedAt.current = 0;
		setStarted(false);
		setStartedWorkoutId(0);
		setTimeSec(elapsedSec);

		let tM = convertSeconds(elapsedSec).split(':')[0];
		let tS = convertSeconds(elapsedSec).split(':')[1];

		if (tM === '00') {
			tM = '0';
		} else {
			tM = tM.replace(/^0+/, '');
		}
		if (tS === '00') {
			tS = '0';
		} else {
			tS = tS.replace(/^0+/, '');
		}

		setAddVal2Val(tS, stoppedWorkoutId);
		setAddVal1Val(tM, stoppedWorkoutId);
	};

	function convertSeconds(s) {
		let min = Math.floor(s / 60);
		let sec = s % 60;
		min = min.toString().length === 1 ? '0' + min.toString() : min.toString();
		sec = sec.toString().length === 1 ? '0' + sec.toString() : sec.toString();
		return min + ':' + sec;
	}

	const daySummary = getDaySummary(data.data);
	const daySummaryCards = [];

	if (daySummary.sets > 0) {
		if (daySummary.volume > 0) {
			daySummaryCards.push({label: 'Objem', value: `${Math.round(daySummary.volume).toLocaleString('cs-CZ')} kg`});
		}

		daySummaryCards.push({label: 'Série', value: daySummary.sets});

		if (daySummary.underLoadSec > 0) {
			daySummaryCards.push({label: 'Pod zátěží', value: convertSeconds(daySummary.underLoadSec)});
		}

		daySummaryCards.push({label: 'Trénink', value: formatDuration(timeToSeconds(daySummary.lastTms) - timeToSeconds(daySummary.firstTms))});
	}

	const selectedWorkout = data.data?.[selectedPlan] || null;
	const selectedWorkoutAddWeight = selectedWorkout ? parseInt(selectedWorkout.LAST_WEIGHT, 10) - parseInt(targetUsrWeight, 10) : 0;
	const selectedWorkoutHint = selectedWorkout && selectedWorkout.TYPEID === 1 && selectedWorkout.WITHMYWEIGHT === 1 ? `${targetUsrWeight} kg + ${selectedWorkoutAddWeight} kg závaží` : '';
	const isInstructorClientView = targetUsrId > 0 && targetUsrId !== (parseInt(usrInfo.usrId, 10) || 0);
	const performanceCards = selectedWorkout
		? [
			{
				title: 'Minule',
				meta: selectedWorkout.PREVIOUS_CRDTS,
				width: selectedWorkout.PERC2,
				color: selectedWorkout.CL,
				value: `${selectedWorkout.PERC1}%`,
				detail: selectedWorkout.PREVIOUS_LIST_CNTWEIGHT3,
			},
			{
				title: 'Nejlepší výkon',
				meta: selectedWorkout.BEST_CRDTS,
				width: selectedWorkout.PERC4,
				color: selectedWorkout.CL3,
				value: `${selectedWorkout.PERC3}%`,
				detail: selectedWorkout.BEST_LIST_CNTWEIGHT,
			},
		]
		: [];

	return (
		<>
			<div className="page_main page_main--fill">
				<AppHeader usrInfo={usrInfo} timerCnt={timerCnt} loading={loading} />
				<Calendar show={showCal} close={closeCal} defaultValue={today} returnValue={todayChange} dataEvents={data.data_cal_events} />
				<ExercisePlan showPlan={showPlan} closePlan={closePlan} data={data.data_plan} updatePlan={updatePlan} targetUsrName={isInstructorClientView ? targetUsrName : ''} />

				<div className={`page exercise-page${usrInfo.sysAdmin === 1 || usrInfo.manager === 1 || usrInfo.instructor === 1 ? ' more' : ''}`}>
					{/* Pevná horní část – nástrojová lišta, denní souhrn a taby cviků se nescrollují. */}
					<div className="exercise-page__head">
					<section className="exercise-page__toolbar-panel">
						<div className="exercise-page__toolbar-row">
							<div className="exercise-page__toolbar-date-group">
								<button type="button" className="exercise-page__toolbar-day-button" onClick={() => prevDay()} aria-label="Předchozí den">
									<img className="icon_left" alt="" />
								</button>
								<button type="button" className="exercise-page__toolbar-day-button" onClick={() => nextDay()} aria-label="Následující den">
									<img className="icon_right" alt="" />
								</button>
																<button type="button" className="exercise-page__date-trigger" onClick={() => showCalendar()}>
									<span className="input-text-date-cal-icon3 exercise-page__date-icon"></span>
									<span>{today} ({todayShortName})</span>
								</button>
																{now !== today ? (
									<button type="button" className="exercise-page__toolbar-link exercise-page__toolbar-link--today" onClick={() => setDTToNow()}>
										<b>Dnes</b>
									</button>
								) : (
									''
								)}
								{isInstructorClientView && shortTargetUsrName !== '' ? <span className="exercise-page__target-user">{shortTargetUsrName}</span> : ''}
							</div>
							<div className="exercise-page__toolbar-actions">
								<button type="button" className="exercise-page__toolbar-icon-button" onClick={() => handleRefresh()} aria-label="Obnovit data">
									<img className="icon_refresh" alt="" />
								</button>
								<button type="button" className="exercise-page__toolbar-icon-button" onClick={() => handlePlan()} aria-label="Upravit plán cvičení">
									<img className="icon_exerciseplan" alt="" />
								</button>
							</div>
						</div>
					</section>

					{/* Dluh / předplaceno – stejné karty jako v sekci home; backend je plní jen pro
					    nečleny bez dnešního výkonu i plánu (stejné podmínky jako NOTMEMBER_NOTE). */}
					{data.TOPAY_TOTAL > 0 ? (
						<div className="home-summary-card home-summary-card--danger exercise-page__topay" key="TOPAY_DEBT">
							<div className="home-summary-card__content home-summary-card__content--eshop txt_l">
								<div className="home-summary-card__group">
									<span className="home-summary-card__label">Nezaplacený nákup</span>
								</div>
								<span className="home-summary-card__value">{data.TOPAY_TOTALS}</span>
							</div>
						</div>
					) : (
						''
					)}

					{data.TOPAY_TOTAL < 0 ? (
						<div className="home-summary-card home-summary-card--success exercise-page__topay" key="TOPAY">
							<div className="home-summary-card__content home-summary-card__content--eshop txt_l">
								<div className="home-summary-card__group">
									<span className="home-summary-card__label">Předplaceno</span>
								</div>
								<span className="home-summary-card__value">{data.TOPAY_TOTALS}</span>
							</div>
						</div>
					) : (
						''
					)}

					{typeof data.NOTMEMBER_NOTE !== 'undefined' && data.NOTMEMBER_NOTE !== '' ? (
						<div className="exercise-page__message exercise-page__message--muted" key="NOTMEMBER_NOTE">
							<span dangerouslySetInnerHTML={{__html: data.NOTMEMBER_NOTE}}></span>
						</div>
					) : (
						''
					)}

					{usrInfo.clubMember === 0 && typeof usrInfo.message !== 'undefined' && usrInfo.message !== '' ? (
						<div className="exercise-page__message exercise-page__message--muted" key="MESSAGES">
							<span dangerouslySetInnerHTML={{__html: usrInfo.message}}></span>
						</div>
					) : (
						''
					)}

					{data.data_plan?.length === 0 ? (
						<div className="exercise-page__message exercise-page__message--muted" key="NO_PLAN">
							{isInstructorClientView ? 'Klient nemá definované cviky.' : 'Nemáš definované cviky.'}
						</div>
					) : (
						''
					)}

					{data.data?.length === 0 && data.data_plan?.length > 0 ? (
						<div className="exercise-page__message exercise-page__message--muted" key="NO_WORKOUT">
							{isInstructorClientView ? 'Na tento den klient nemá nastavený plán tréninku. Použij ikonku vpravo.' : 'Na tento den nemáš nastavený plán tréninku. Použij ikonku vpravo.'}
						</div>
					) : (
						''
					)}

					{data.data?.length > 0 ? (
						<>
							{daySummaryCards.length > 0 ? (
								<section className="exercise-page__day-summary">
									{daySummaryCards.map((card) => (
										<div className="home-summary-card exercise-page__day-summary-card" key={card.label}>
											<div className="home-summary-card__content">
												<span className="home-summary-card__eyebrow">{card.label}</span>
												<span className="home-summary-card__value">{card.value}</span>
											</div>
										</div>
									))}
								</section>
							) : (
								''
							)}

							<div className="exercise-page__tab-row" id="TAB_PANEL_MAIN">
								{data.data.map((item, index) => (
									<button
										type="button"
										className={`exercise-page__tab${selectedPlan === index ? ' is-active' : ''}`}
										key={item.WORKOUTID || index}
										id={'LIST_TAB_EXERCISE_' + index}
										onClick={() => selectWorkout(index)}
									>
										<span className="exercise-page__tab-dot" style={{backgroundColor: item.CL}}></span>
										<span className="exercise-page__tab-label" id={'LIST_TAB_EXERCISE_TXT_' + index}>
											{formatWorkoutName(item)}
										</span>
										<span className="exercise-page__tab-accent" style={{backgroundColor: item.COLOR}}></span>
									</button>
								))}
							</div>
						</>
					) : (
						''
					)}
					</div>

					{/* Scrolluje se jen tělo se cviky – hlavička nad ním zůstává pevná. */}
					<div className="exercise-page__body">
					{data.data?.length > 0 ? (
						<>
							<div className="exercise-page__my-weight">
								{!isEditingWeight ? (
									<span className="exercise-page__my-weight-label">
										{isInstructorClientView ? 'Hmotnost klienta: ' : 'Moje hmotnost: '}
										{targetUsrWeight > 0 ? `${targetUsrWeight} kg` : '—'}
										<button
											type="button"
											className="exercise-page__my-weight-btn"
											onClick={() => {
												setEditWeightValue(targetUsrWeight > 0 ? targetUsrWeight.toString() : '');
												setIsEditingWeight(true);
											}}
											aria-label={isInstructorClientView ? 'Upravit hmotnost klienta' : 'Upravit moji hmotnost'}
										>
											<img className="icon1 edit" alt="" />
										</button>
									</span>
								) : (
									<span className="exercise-page__my-weight-label">
										{isInstructorClientView ? 'Hmotnost klienta: ' : 'Moje hmotnost: '}
										<input
											type="number"
											step="0.01"
											value={editWeightValue}
											onChange={(e) => setEditWeightValue(e.target.value)}
											onKeyDown={(e) => {
												if (e.key === 'Enter') {
													handleSaveWeight();
												} else if (e.key === 'Escape') {
													setIsEditingWeight(false);
												}
											}}
											className="exercise-page__my-weight-input"
											placeholder="0.00"
											autoFocus
										/>
										<span>kg</span>
										<button
											type="button"
											className="exercise-page__my-weight-btn"
											onClick={handleSaveWeight}
											aria-label="Uložit hmotnost"
										>
											<img className="icon1 ok1" alt="" />
										</button>
									</span>
								)}
							</div>

							{selectedWorkout ? (
								<section className="exercise-page__workout-card" style={{'--exercise-accent': selectedWorkout.COLOR || '#8acaa3'}}>
									<div className="exercise-page__workout-top">
										<div className="exercise-page__workout-main">
											<div className="exercise-page__workout-title-row">
												<h2 className="exercise-page__workout-title exercise-page__entry-workout-name">{selectedWorkout.NAME}</h2>
												{selectedWorkout.NOTE !== '' ? <span className="exercise-page__workout-title-note">{selectedWorkout.NOTE}</span> : ''}
											</div>
											{selectedWorkoutHint !== '' ? <div className="exercise-page__workout-subtitle">{selectedWorkoutHint}</div> : ''}

											{today === now ? (
												<div className="exercise-page__entry-panel exercise-page__entry-panel--inline">
												<div className="exercise-page__entry-controls">
												{selectedWorkout.TYPEID === 1 ? (
													<>
														<div className="exercise-page__entry-field">
															<div className="exercise-page__entry-input-group">
																<input className="input-text exercise-page__entry-input" type="number" maxLength={3} placeholder="Opakování" value={addVal1[selectedWorkout.WORKOUTID] ?? ''} onChange={(e) => setAddVal1Val(e.target.value, selectedWorkout.WORKOUTID)} aria-label="Opakování" />
																<span className="exercise-page__entry-unit">x</span>
															</div>
														</div>
														<div className="exercise-page__entry-field">
															<div className="exercise-page__entry-input-group">
																<input className="input-text exercise-page__entry-input" type="number" step={0.01} maxLength={5} placeholder="Váha" value={addVal2[selectedWorkout.WORKOUTID] ?? ''} onChange={(e) => setAddVal2Val(e.target.value, selectedWorkout.WORKOUTID)} aria-label="Váha" />
																<span className="exercise-page__entry-unit">kg</span>
															</div>
														</div>
													</>
												) : (
													<>
														<div className="exercise-page__entry-field">
															<div className="exercise-page__entry-input-group">
																<input className="input-text exercise-page__entry-input" type="number" maxLength={3} placeholder="Minuty" value={addVal1[selectedWorkout.WORKOUTID] ?? ''} onChange={(e) => setAddVal1Val(e.target.value, selectedWorkout.WORKOUTID)} aria-label="Minuty" />
																<span className="exercise-page__entry-unit">min</span>
															</div>
														</div>
														<div className="exercise-page__entry-field">
															<div className="exercise-page__entry-input-group">
																<input className="input-text exercise-page__entry-input" type="number" maxLength={2} placeholder="Sekundy" value={addVal2[selectedWorkout.WORKOUTID] ?? ''} onChange={(e) => setAddVal2Val(e.target.value, selectedWorkout.WORKOUTID)} aria-label="Sekundy" />
																<span className="exercise-page__entry-unit">sek</span>
															</div>
														</div>
														<button type="button" className="exercise-page__timer-toggle" onClick={() => showHideTimer(selectedWorkout.WORKOUTID)}>
															<img className="icon_timer" alt="" />
														</button>
													</>
												)}

													<button type="button" className="exercise-page__add-button" onClick={() => addWorkout(selectedWorkout.WORKOUTID, selectedWorkout.TYPEID)} aria-label="Přidat záznam">
													+
												</button>
											</div>
												{selectedWorkout.TYPEID !== 1 ? (
													<div className="hidden exercise-page__timer-panel" id={'TIMER_' + selectedWorkout.WORKOUTID}>
														<div className="exercise-page__timer-shell">
															<div className="exercise-page__timer-kicker">Časovač</div>
															<div className="exercise-page__timer-value" id={'TIMER_TIME_' + selectedWorkout.WORKOUTID}>
																{timerOwnerWorkoutId === selectedWorkout.WORKOUTID ? convertSeconds(timeSec) : '00:00'}
															</div>
														</div>
														<div className="exercise-page__timer-actions">
															<input className="button big green TIMER_START" type="button" value="Start" id={'TIMER_START_' + selectedWorkout.WORKOUTID} onClick={() => startTimer(selectedWorkout.WORKOUTID)} />
															<input className="button big red hidden TIMER_STOP" type="button" value="Stop" id={'TIMER_STOP_' + selectedWorkout.WORKOUTID} onClick={() => stopTimer()} />
														</div>
													</div>
												) : (
													''
												)}
												</div>
											) : (
												''
											)}
										</div>
									</div>

									<div className="exercise-page__records">
										{selectedWorkout.recs?.map((rec, index2) => (
											<ExerciseWorkoutRec key={index2} item={selectedWorkout} rec={rec} index2={index2} sOrder={index2 + 1} today={today} setData={setData} targetUsrId={targetUsrId} applyTargetUsrMeta={applyTargetUsrMeta} />
										))}
									</div>

									<div className="exercise-page__performance-grid">
										{performanceCards.map((card) => (
											<div className="exercise-page__performance-card" key={card.title}>
												<div className="exercise-page__performance-head">
													<div className="exercise-page__performance-title">{card.title}</div>
													<div className="exercise-page__performance-meta">{card.meta}</div>
												</div>
												<div className="exercise-page__performance-bar">
													<div className="exercise-page__performance-fill" style={{width: `${card.width}%`, backgroundImage: `linear-gradient(to top, ${card.color}, #bbbbbb 110%)`}}>
														<span className="exercise-page__performance-value">{card.value}</span>
													</div>
												</div>
												<div className="exercise-page__performance-detail-wrap">
													<div className="exercise-page__performance-detail" dangerouslySetInnerHTML={{__html: card.detail}}></div>
												</div>
											</div>
										))}
									</div>

									<div className="exercise-page__chart-wrap">
										<ChartArea className="exercise-page__chart" data={selectedWorkout.data_graph.data} labels={selectedWorkout.data_graph.labels} color={selectedWorkout.COLOR} linesColor={'#c8d4ce'} variant="glass" height="100%" />
									</div>
								</section>
							) : (
								''
							)}
						</>
					) : (
						''
					)}
					</div>
				</div>
			</div>
		</>
	);
}

